/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createAccount.defs.js'
export * as $defs from './createAccount.defs.js'
